import { render } from "./Spinner.vue?vue&type=template&id=d81083b4&scoped=true"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=d81083b4&scoped=true&lang=css"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d81083b4"]])

export default __exports__